import { ApplianceModel } from '@common/models';

import { staticContentService } from '../../static-content-api/staticContentService';

const sinksApi = staticContentService.injectEndpoints({
    endpoints: (builder) => ({
        fetchInStoreSinks: builder.query<ApplianceModel[], { url: string }>({
            query: ({ url }) => ({
                url,
                method: 'GET',
            }),
        }),
    }),
});

export const { useFetchInStoreSinksQuery } = sinksApi;
